export default (params) => ({
  trigger: {
    name: 'service_selector.deselect',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'order_block',
          'order_block_summary',
          'configurator',
          'configurator_overlay',
          'shopping_cart',
        ],
      },
    },
    event: {
      name: 'remove_item',
      params: {
        list: null,
      },
    },
  },
});
